const TOKEN_EXPIRE_TIME_IN_MINUTES = 55;
const SESSION_INACTIVITY_EXPIRE_TIME_IN_MINUTES = 15;

class PrincipalService {
    constructor(config, $rootScope, $http, $q, $timeout, $state, storageService) {
        this.serverUrl = storageService.getManagerHostname();
        this.clientId = config.clientId;
        this.$rootScope = $rootScope;
        this.$http = $http;
        this.$q = $q;
        this.$timeout = $timeout;
        this.$state = $state;
        this.config = config;
        this.storageService = storageService;
        this.clearIdentity();
    }

    startTimer() {
        if (angular.isUndefined(this.lastThreadId)) {
            this.resetTokenExpireTime();
            this.masterTimeThreadId = 0;
            this.lastThreadId = 0;
        } else {
            this.lastThreadId++;
        }
        this.firstThreadTimer();
    }

    resetTokenExpireTime() {
        const unixDate = new Date(this.storageService.getAllTokens().accessTokenExpiresOn).valueOf()
        this.tokenExpireTime = moment(new Date((unixDate - 1 * 60000)));
    }

    resetSessionExpireTime() {
        this.sessionExpireTime = moment(new Date()).add(SESSION_INACTIVITY_EXPIRE_TIME_IN_MINUTES, 'm').toDate();
    }

    timeLeftBeforeTokenExpire() {
        if (this.curentTime && this.sessionExpireTime) {
            return moment(this.sessionExpireTime).diff(moment(this.curentTime), 'seconds');
        }
    }

    firstThreadTimer() {
        if (this.masterTimeThreadId === this.lastThreadId) {
            this.selfLogoutTimer();
        }
        /*else {
            console.log('---kill thread with id: ', this.lastThreadId);
        }*/
    }

    selfLogoutTimer() {
        if (!this.tokenExpireTime) {
            return;
        }
        else if (this.isSessionExpired()) {
            this.forceLogout(true);
        }
        else {
            if (this.ifTokenExpired()) {
                this.forceLogout(true);
            }
            this.$timeout(() => {
                this.curentTime = new Date();
                this.selfLogoutTimer();
            }, 1000);
        }
    }

    handleResponse(req) {
        return this.$q((resolve, reject) => this.$http(req).then(resp => {
            if (resp.data) {
                resp.data.tableState = resp.data.metadata && resp.data.metadata !== null ? TableState.fromRaw(resp.data.metadata) : null;
            }
            resolve(resp);
        }, err => reject(this.handleError(err, req.responseType === ARRAYBUFFER_TYPE))
        ));
    }

    ifTokenExpired() {
        return moment(this.curentTime).isAfter(this.tokenExpireTime);
    }

    isSessionExpired() {
        return moment(this.curentTime).isAfter(this.sessionExpireTime);
    }

    clearIdentity() {
        this.sessionExpireTime = undefined;
        this.tokenExpireTime = undefined;
        this.lastThreadId = undefined;
        this._identity = undefined;
        this._authenticated = false;
    }

    isIdentityResolved() {
        return angular.isDefined(this._identity);
    }

    getUsername() {
        if (this.isIdentityResolved()) return this._identity.username;
        return undefined;
    }

    isAuthenticated() {
        return this._authenticated;
    }

    isInRole(role) {
        if (!this.isAuthenticated() || angular.isUndefined(this._identity.role)) return false;
        return this._identity.role === role;
    }

    isInAnyRole(roles) {
        if (!this.isAuthenticated() || angular.isUndefined(this._identity.role)) return false;
        for (let i = 0; i < roles.length; i++) {
            if (this.isInRole(roles[i])) return true;
        }
        return false;
    }

    authenticate(identity) {
        this._identity = identity;
        this._authenticated = angular.isDefined(identity);

        if (this.isAuthenticated()) {
            this.startTimer();
            this.storageService.setUser(identity);
        } else {
            this.forceLogout();
        }
    }

    identity(force) {
        let deferred = this.$q.defer();
        // const gauth2 = gapi.auth2;
        if (force) this._identity = undefined;

        if (angular.isDefined(this._identity)) {
            deferred.resolve(this._identity);
            return deferred.promise;
        }

        let uuid = this.storageService.getUserUuid();
        let token = this.storageService.getToken();
        if (uuid && token) {
            // const person = gauth2.getAuthInstance().currentUser.get().getBasicProfile();
            const resp = {
                username: uuid,
                // name: 'iperzic',
                email: uuid,
                role: 'Administrator',
                status: 1,
                uuid: uuid
            };
            this.authenticate(resp);
            deferred.resolve(this.storageService.getUser());
        } else {
            deferred.resolve();
        }
        return deferred.promise;
    }

    setTokenFn(token) {
        this.storageService.setToken(token)
        this.resetTokenExpireTime();
    }

    setProxRegTokenFn(token) {
        this.storageService.setProxRegToken(token)
    }

    updateTokenFn() {
        this.resetSessionExpireTime();
    }

    isTokenPersisted() {
        let token = this.storageService.getToken();
        return angular.isDefined(token) && token !== '';
    }

    forceLogout(isTokenExpired, isErrorTimeOut) {
        // gapi.auth2.getAuthInstance().signOut();
        this.storageService.onLogout();
        this.clearIdentity();
        this.$rootScope.$emit("force-logout");
        this.outOnTokenExpired = isTokenExpired;
        this.outOnUnreachable = isErrorTimeOut;
        this.$timeout(() => {
            this.$state.go("login");
        }, 0);
    }

    checkLogout() {
        if (!this.storageService.getToken()) {
            this.$timeout(() => {
                this.forceLogout();
            }, 0);
        }
    }
}
PrincipalService.$inject = ['config', '$rootScope', '$http', '$q', '$timeout', '$state', 'storageService'];

module.exports = PrincipalService;



// WEBPACK FOOTER //
// ./src/azurebackup/services/principal.service.js